module.exports = __webpack_public_path__ + "img/hotstyleshow7.c77776b5.jpg";